// extracted by mini-css-extract-plugin
export default {"title":"styles_title__Lt3mx","dataBank":"styles_dataBank__SGPi3","name":"styles_name__rGM+c","dataItem":"styles_dataItem__8X0b5"};